import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildMediaBlockQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const mediaImageId = escapePrintViewText(
        content.media && content.media.related_media_id ? content.media.related_media_id : ''
    )
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const mediaSectionHtml = mediaImageId ? `<p>image media id: ${mediaImageId}</p>` : ''

    return `${questionSectionHtml}${mediaSectionHtml}`
}

export {buildMediaBlockQuestionPrintView}
